import React, { ReactNode } from 'react'

import RAlways from 'ramda/src/always'
import RCond from 'ramda/src/cond'
import RPropEq from 'ramda/src/propEq'

import { Flex } from 'stardust'
import styled from 'styled-components'
import { borderRadius } from 'styled-system'

const Moment = () => (
  <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#A565EF"
    />
    <path
      d="M6.95337 8.12512C7.08281 8.12512 7.18774 8.23006 7.18774 8.3595C7.18774 8.48894 7.08281 8.59387 6.95337 8.59387C6.82393 8.59387 6.71899 8.48894 6.71899 8.3595C6.71899 8.23006 6.82393 8.12512 6.95337 8.12512"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.9458 12.1401C6.739 13.6443 8.2997 14.5857 10.0002 14.5858C10.1052 14.5858 10.2089 14.582 10.3127 14.5751C10.3989 14.5693 10.4846 14.5612 10.5696 14.5508"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0245 9.70193C16.8614 5.86083 13.6436 2.86283 9.80056 2.97162C5.95754 3.08041 2.91443 6.25565 2.96898 10.0998C3.02354 13.944 6.15552 17.0316 10.0001 17.0313C10.1051 17.0313 10.2088 17.0313 10.3126 17.0238"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5288 8.53753C11.7925 8.11615 12.2545 7.86023 12.7516 7.86023C13.2487 7.86023 13.7108 8.11615 13.9744 8.53753"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0244 9.7019L10.3125 17.0238"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3057 17.0313V16.4201C10.3057 12.7056 13.3168 9.69446 17.0313 9.69446"
      stroke="white"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Observation = () => (
  <svg fill="#fff" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" />
  </svg>
)

const Plan = () => (
  <svg
    fill="#fff"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <path
        d="M11.5 2L6 11h11l-5.5-9zm0 3.84L13.43 9H9.56l1.94-3.16zM17 13c-2.49 0-4.5 2.01-4.5 4.5S14.51 22 17 22s4.5-2.01 4.5-4.5S19.49 13 17 13zm0 7a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zM2.5 21.5h8v-8h-8v8zm2-6h4v4h-4v-4z"
        id="a"
      />
    </defs>
    <g transform="translate(0 -1)" fillRule="evenodd">
      <mask id="b">
        <use xlinkHref="#a" />
      </mask>
      <g mask="url(#b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
)

const Story = () => (
  <svg fill="#fff" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 19V6h8v13H3zm18 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z" />
  </svg>
)

const Table = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53125 5.31201C4.53125 4.88054 4.88103 4.53076 5.3125 4.53076H14.6875C15.119 4.53076 15.4687 4.88054 15.4687 5.31201V14.687C15.4687 15.1185 15.119 15.4683 14.6875 15.4683H5.3125C4.88103 15.4683 4.53125 15.1185 4.53125 14.687V5.31201Z"
      stroke="white"
      strokeWidth="0.78125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.53076V15.4683"
      stroke="white"
      strokeWidth="0.78125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53125 9.99951H15.4687"
      stroke="white"
      strokeWidth="0.78125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Circle = styled(Flex)`
  width: 20px;
  height: 20px;
  ${borderRadius};
`

interface Props {
  type: string
}

const moment = RPropEq('type', 'moment')
const observation = RPropEq('type', 'observation')
const plan = RPropEq('type', 'learning_plan')
const story = RPropEq('type', 'learning_story')
const table = RPropEq('type', 'learning_table')

export const colorOfType = RCond<Props, Nullable<string>>([
  [moment, RAlways('moment')],
  [observation, RAlways('observation')],
  [plan, RAlways('plan')],
  [story, RAlways('story')],
  [table, RAlways('table')],
])

export const iconOfType = RCond<Props, ReactNode>([
  [moment, () => <Moment />],
  [observation, () => <Observation />],
  [plan, () => <Plan />],
  [story, () => <Story />],
  [table, () => <Table />],
])

const DocumentIcon = (props: Props) => (
  <Circle alignItems="center" bg={colorOfType(props)} borderRadius={4} justifyContent="center">
    {iconOfType(props)}
  </Circle>
)

DocumentIcon.displayName = 'DocumentIcon'

export default React.memo(DocumentIcon)
